import { render, staticRenderFns } from "./audit-dialog.vue?vue&type=template&id=8f5d4dc4&scoped=true&"
import script from "./audit-dialog.vue?vue&type=script&lang=js&"
export * from "./audit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5d4dc4",
  null
  
)

export default component.exports